import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/Button';
import { ModalShell } from '../../ui/ModalShell/ModalShell';
import { TranslationKey } from '../../i18n/translationKeys';
import type { TransphereContactModalProps } from './types';

export const TransphereContactModal: React.FC<TransphereContactModalProps> = ({ heading, message, onClose }) => {
    const { t } = useTranslation();
    const closeLabel = t(TranslationKey.Home.TransphereBanner.ContactClose);

    return (
        <ModalShell
            heading={heading}
            onClose={onClose}
            dismissAriaLabel={closeLabel}
            rootTestId="transphere-contact-modal"
            titleTestId="transphere-contact-modal-title"
            dismissTestId="transphere-contact-modal-dismiss-btn"
            footer={
                <Button variant="secondary" data-testid="transphere-contact-modal-close-btn" type="button" onClick={onClose}>
                    {closeLabel}
                </Button>
            }
        >
            <p data-testid="transphere-contact-modal-message" className="text-s text-content-secondary">
                {message}
            </p>
        </ModalShell>
    );
};
